import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Règle produit : dès qu'un vin a été commandé, sa quantité totale
// (toutes commandes passées, hors annulées) doit pouvoir s'afficher partout.
export function useOrderedQuantities() {
  const { user } = useAuth();
  const [map, setMap] = useState({});

  useEffect(() => {
    if (!user) {
      setMap({});
      return;
    }
    api
      .get("/orders/mine")
      .then((res) => {
        const m = {};
        res.data
          .filter((o) => o.status !== "annulee")
          .forEach((o) => o.items.forEach((it) => (m[it.wine_id] = (m[it.wine_id] || 0) + it.qty)));
        setMap(m);
      })
      .catch(() => {});
  }, [user]);

  return map;
}
